//import Vue from 'vue';
import Common from '@/utils/common';
export const name = "dsrebound";//必须定义一个name的常量，配合自动注册逻辑使用
export default {
  bind(el, binding) {
    //binding.value: horizontal 水平，vertical 垂直（默认）

    //console.info(binding.value);

    let _bingOptions = binding.value || {};

    //Vue.nextTick(() => {

    //console.info('el ---> ', el);
    el.classList.add('v--dsrebound');

    let _direction_ = 'vertical';
    if (_bingOptions.direction === 'horizontal') {
      _direction_ = 'horizontal';
    }
    // console.log(`%c _direction_: ${_direction_}`, "color: #69FF4E");

    let _MAX_ = 120; //最大可回弹滑动距离（px）
    let _DSREBOUNDDURATION_ = 200; //回弹动画时长（ms）
    let _HINDRANCE_ = 0.5; //拉动阻力（0 ~ 1，值越小阻力越大）
    if (_bingOptions.hindrance && _bingOptions.hindrance >= 0) {
      _HINDRANCE_ = _bingOptions.hindrance;
    }

    let _touchstart_ = 0; //开始触摸的位置
    let _pulldistance_ = 0; //已拉动距离


    function pull(val) {
      //:style="{ transform: 'translate3d(' + 0 + 'vw, ' + _pulldistance_ + 'vw, ' + 0 + 'vw)', 'transition-duration': '300ms' }"
      if (_direction_ === 'vertical') {
        el.style.transform = 'translate3d(0vw, ' + val + 'vw, 0vw)';
      } else if (_direction_ === 'horizontal') {
        el.style.transform = 'translate3d(' + val + 'vw, 0vw, 0vw)';
      }
    }

    function touchstart(e) {
        // console.info('元素 touchmove：', e);

        //拉动时关闭过渡动画效果
        el.style.transitionDuration = '0ms'

        if (_direction_ === 'vertical') {
          //垂直
          // console.info('元素垂直滚动，距离顶部的距离 scrollTop：', el.scrollTop);

          // console.info('元素垂直滚动，距离底部的距离 scrollHeight - clientHeight - scrollTop：', el.scrollHeight - el.clientHeight - el.scrollTop);
          // console.info('el.scrollHeight >>>>> ：', el.scrollHeight);
          // console.info('el.clientHeight >>>>> ：', el.clientHeight);
          // console.info('el.scrollTop >>>>> ：', el.scrollTop);

          //记录开始触摸的位置
          _touchstart_ = e.touches[0].pageY + el.scrollTop;
          // console.info('touchstart --->>> 开始时的位置 _touchstart_：', _touchstart_);

        } else if (_direction_ === 'horizontal') {
          //水平
          // console.info('元素水平滚动距离 scrollLeft：', el.scrollLeft);

          // console.info('元素水平滚动，距离左侧的距离 scrollWidth - clientWidth - scrollLeft：', el.scrollWidth - el.clientWidth - el.scrollLeft);
          // console.info('el.scrollWidth >>>>> ：', el.scrollWidth);
          // console.info('el.clientWidth >>>>> ：', el.clientWidth);
          // console.info('el.scrollLeft >>>>> ：', el.scrollLeft);

          //记录开始触摸的位置
          _touchstart_ = e.touches[0].pageX + el.scrollLeft;
          // console.info('touchstart --->>> 开始时的位置 _touchstart_：', _touchstart_);
        }
    }

    let _fromtop_ = 0; //距离顶端
    let _frombottom_ = 0; //距离底部
    let _fromleft_ = 0; //距离左端
    let _fromright_ = 0; //距离右底部
    function touchmove (e) {
        if (el.classList.contains('disabled-touchmove')) {
          return;
        }

        setTimeout(() => {

          // console.info('元素 touchmove', e);
          if (_direction_ === 'vertical') {
            //垂直
            _fromtop_ = el.scrollTop;
            _frombottom_ = el.scrollHeight - el.clientHeight - el.scrollTop;
            // console.info('_frombottom_', _frombottom_);
            // console.info('scrollHeight', el.scrollHeight, 'clientHeight', el.clientHeight, 'scrollTop', el.scrollTop);
            // console.info('_fromtop_', _fromtop_, '_frombottom_', _frombottom_, '_pulldistance_', _pulldistance_);

            if (_fromtop_ === 0 || _frombottom_ === 0 || _pulldistance_ > 0) {
              if (_fromtop_ === 0 && e.targetTouches[0].pageY > _touchstart_) {
                if (el.classList.contains('disabled-touchmove-pulldown')) {
                  return;
                }

                // console.info('%c ↓↓↓ ----------', 'color: red');
                //拉动的距离，当前滑动的Y轴大于按下的Y轴，表示正在下拉（或回滑，反正大于按下的坐标就是向下拉动了）
                let diffTop = e.targetTouches[0].pageY - _touchstart_;
                //计算距离
                let top = Math.pow(diffTop, _HINDRANCE_);
                //px -> vw
                top = Common.fnPxToViewPort(top);
                // console.info("下拉距离计算结果 vw：top = ", top);

                //当下拉内容区域滚动条位于顶端时才开始进行下拉动作
                if (top <= _MAX_) {
                  // console.info("执行下拉");
                  _pulldistance_ = top;
                  pull(_pulldistance_);
                } else {
                  _pulldistance_ = _MAX_;
                  pull(_pulldistance_);
                  // console.info("已达到最大下拉距离：", _MAX_);
                }
              } else if (_frombottom_ === 0 && e.targetTouches[0].pageY < _touchstart_) {
                if (el.classList.contains('disabled-touchmove-slideup')) {
                  return;
                }

                // console.info('%c ↑↑↑ ----------', 'color: red');
                //拉动的距离，当前滑动的Y轴小于按下的Y轴，表示正在上滑
                let diffBottom = _touchstart_ - e.targetTouches[0].pageY - _fromtop_;
                // console.log('%c diffBottom = ' + diffBottom + ', _touchstart_ = ' + _touchstart_ + ', pageY = ' + e.targetTouches[0].pageY + ', _fromtop_ = ' + _fromtop_ + '', 'color: #69FF4E');

                if (diffBottom > 0) {
                  //计算距离
                  let bottom = Math.pow(Math.abs(diffBottom), _HINDRANCE_);
                  //px -> vw
                  bottom = Common.fnPxToViewPort(bottom);
                  // console.info("上滑距离计算结果 vw：bottom = ", e.targetTouches[0].pageY + _fromtop_ < _touchstart_ ? -bottom : bottom);

                  if (bottom <= _MAX_) {
                    // console.info("执行上滑");
                    _pulldistance_ = e.targetTouches[0].pageY + _fromtop_ < _touchstart_ ? -bottom : bottom;
                    pull(_pulldistance_);
                  } else {
                    _pulldistance_ = _MAX_;
                    pull(_pulldistance_);
                    // console.info("已达到最大上滑距离：", _MAX_);
                  }
                }

              } else {
                // console.info('%c else ----------', 'color: red');
                //if (_pulldistance_ !== 0) {
                _pulldistance_ = 0;
                pull(_pulldistance_);
                //}
              }
            }
          } else if (_direction_ === 'horizontal') {
            //水平
            _fromleft_ = el.scrollLeft;
            _fromright_ = el.scrollWidth - el.clientWidth - el.scrollLeft;
            // console.info('_fromright_', _fromright_);

            if (_fromleft_ === 0 || _fromright_ === 0 || _pulldistance_ > 0) {
              if (_fromleft_ === 0 && e.targetTouches[0].pageX > _touchstart_) {
                // console.info('↓↓↓ ----------')
                //拉动的距离，当前滑动的X轴大于按下的X轴，表示正在右拉（或回滑，反正大于按下的坐标就是向右拉动了）
                let diffLeft = e.targetTouches[0].pageX - _touchstart_;
                //计算距离
                let left = Math.pow(diffLeft, _HINDRANCE_);
                //px -> vw
                left = Common.fnPxToViewPort(left);
                // console.info("右拉距离计算结果 vw：left = ", left);

                //当下拉内容区域滚动条位于顶端时才开始进行下拉动作
                if (left <= _MAX_) {
                  // console.info("执行右拉");
                  _pulldistance_ = left;
                  pull(_pulldistance_);
                } else {
                  _pulldistance_ = _MAX_;
                  pull(_pulldistance_);
                  // console.info("已达到最大右拉距离：", _MAX_);
                }
              } else if (_fromright_ === 0 && e.targetTouches[0].pageX < _touchstart_) {
                // console.info('---------- ↑↑↑')
                //拉动的距离，当前滑动的X轴小于按下的X轴，表示正在左滑
                let diffRight = _touchstart_ - e.targetTouches[0].pageX - _fromleft_;
                // console.log('%c diffRight = ' + diffRight + ', _touchstart_ = ' + _touchstart_ + ', pageX = ' + e.targetTouches[0].pageX + ', _fromleft_ = ' + _fromleft_ + '', 'color: #69FF4E');

                if (diffRight > 0) {
                  //计算距离
                  let right = Math.pow(Math.abs(diffRight), _HINDRANCE_);
                  //px -> vw
                  right = Common.fnPxToViewPort(right);
                  // console.info("左滑距离计算结果 vw：right = ", e.targetTouches[0].pageX + _fromleft_ < _touchstart_ ? -right : right);

                  if (right <= _MAX_) {
                    // console.info("执行左拉");
                    _pulldistance_ = e.targetTouches[0].pageX + _fromleft_ < _touchstart_ ? -right : right;
                    pull(_pulldistance_);
                  } else {
                    _pulldistance_ = _MAX_;
                    pull(_pulldistance_);
                    // console.info("已达到最大左滑距离：", _MAX_);
                  }
                }

              } else {
                //if (_pulldistance_ !== 0) {
                _pulldistance_ = 0;
                pull(_pulldistance_);
                //}
              }
            }
          }

        }, 0);

    }

    function touchend(e) {
        setTimeout(() => {
          //回弹时开启过渡动画效果
          el.style.transitionDuration = _DSREBOUNDDURATION_ + 'ms'
          _pulldistance_ = 0;
          pull(_pulldistance_);
        }, 0);
    }

    el.addEventListener('touchstart', touchstart, false);
    el.__touchstart__ = touchstart;
    el.addEventListener('touchmove', touchmove, false);
    el.__touchmove__ = touchmove;
    el.addEventListener('touchend', touchend, false);
    el.__touchend__ = touchend;


    /**
     * el.addEventListener(event, callback, useCapture);
     * param {String} event 要监听的事件名称（click、dblclick、mousedown...）
     * param {Function} callback 需要执行的函数
     * param {Boolean} useCapture 触发类型（true事件在捕获阶段执行，false事件在冒泡阶段执行；默认是false）
     * //当useCapture为true的时候是在捕获阶段触发事件 (捕获事件触发顺序是由父到子)
     * //当useCapture为false的时候是在冒泡阶段触发事件（默认为false）(冒泡事件触发顺序是由子到父)
     * //第三个参数不一定是 bool 值，也可以是个对象，它提供了更多选项：
     * // {
     * //    once：只执行一次。
     * //    passive：承诺此事件监听不会调用 preventDefault，这有助于性能。
     * //    useCapture：是否捕获（否则冒泡）。
     * // }
    */
    //});
  },
  unbind(el) {
    if (el.__touchstart__) {
      document.removeEventListener('touchstart', el.__touchstart__);
      delete el.__touchstart__;
    }
    if (el.__touchmove__) {
      document.removeEventListener('touchmove', el.__touchmove__);
      delete el.__touchmove__;
    }
    if (el.__touchend__) {
      document.removeEventListener('touchend', el.__touchend__);
      delete el.__touchend__;
    }
  }
};
